// extracted by mini-css-extract-plugin
export default {"container":"NoMessages_container__b+PWb"};